import React from "react";
import { FormSelect } from "tvs-unified-lib/dist";


export type SelectOptionType = {
  label: string | React.ReactNode;
  value: any;
  disabled?: boolean;
  other?: any;
};

interface OperatorSelectProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  options: SelectOptionType[];
  required: boolean;
}

const OperatorSelect: React.FC<OperatorSelectProps> = ({
  value,
  onChange,
  placeholder = "Select Operator",
  disabled = false,
  options,
  required = false,
}) => {
  const selectedOption = options?.find((o) => o.value === value) ?? null;

  return (
    <div>
      <FormSelect
        options={options}
        isMultiple={false}
        withCheckbox={false}
        withSearch={false}
        keepOpen={false}
        placeholder={placeholder}
        value={selectedOption ? [selectedOption] : []}
        formLabel={undefined}
        isRequired={required}
        onChange={(arr: SelectOptionType[]) => {
          const v = arr && arr.length > 0 ? arr[0].value : "";
          onChange(v);
        }}
        hasError={false}
        disabled={disabled}
        loading={false}
      />
    </div>
  );
};

export default OperatorSelect;
